import "./Spinner.css";

/**
 * @typedef {"small" | "medium" | "large"} SpinnerSize
 */

/**
 * Componente reutilizable para mostrar un indicador de carga.
 *
 * @param {Object} props
 * @param {SpinnerSize} [props.size="medium"]
 * Tamaño del spinner. Valores permitidos:
 * - "small": 20px
 * - "medium": 36px
 * - "large": 56px
 *
 * @param {string} [props.text=""]
 * Texto opcional que se muestra junto al spinner.
 *
 * @param {string} [props.className=""]
 * Clase CSS personalizada para el contenedor del spinner.
 *
 * @returns {JSX.Element}
 */
const Spinner = ({ size = "medium", text = "", className = "" }) => {
  return (
    <div className={`spinnerContainer ${className}`}>
      <span
        className={`spinner spinner--${size}`}
        role="status"
        aria-label={text || "Cargando"}
      />

      {text && <span className="spinnerText">{text}</span>}
    </div>
  );
};

export default Spinner;
